import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Button, FormLabel, Grid, Typography, Stack } from "@mui/material";
import { Months, Years } from "../../utils/constants"
import { GetAgedeptDetails } from "../../Services/api";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { getPaginationCount, customDateFormat } from "../CashAllocation/utils";
import { useStyles } from '../bankTransactions/bankTranscationContainerStyles'
import { CommonPaginationContainer } from "../common";
import format from "date-fns/format";
import instance from "../../redux/api";

export const AgedeptDetails = () => {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const agedReportContainer = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    overFlow: "auto",
  };

  const agedReportText = {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "400",
    marginTop: 5,
  };

  const classes = useStyles();

  const handleVarianceResponse = (response) => {

    console.log("Response : ", response)

    if (response.status === 200) {
      setPageState((old) => ({
        ...old,
        total: response?.data?.count,
        data: response.data.data || [],
      }));
    } else {
      setPageState((old) => ({
        ...old,
        total: response?.data?.count,
        data: [],
      }));
      setPaginationCount(0);
    }
  };

  useEffect(() => {
    loadData();
  }, [pageState?.pageSize, pageState?.page])

  const loadData = async (isClear = false) => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));


      const fileName = localStorage.getItem('selectedFileName');
      
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${
        pageState?.pageSize
      }&file_name=${fileName}`;
      
      const response = await instance.get(`${GetAgedeptDetails}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      handleVarianceResponse(response);
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.pageSize, pageState?.total]);

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const columns = [
    {
      field: "Class_of_Business",
      headerName: "Class of Business",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "file_month",
      headerName: "File Month",
      headerAlign: "center",
      width: 150,
      renderCell: (params) => Months.find(month => month.value === parseInt(params.value)).name
    },
    {
      field: "file_year",
      headerName: "File Year",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "Year_of_Account",
      headerName: "Year of Account",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Syndicate_Binder",
      headerName: "Syndicate Binder",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Policy_Line_Ref",
      headerName: "Policy Line Ref",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "Policy_Status",
      headerName: "Policy Status",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Policy_Activity_Status",
      headerName: "Policy Activity Status",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "Inception_Date",
      headerName: "Inception Date",
      headerAlign: "center",
      width: 200,
      renderCell: (params) => <span>{ params.value && format(new Date(params.value), "dd-MM-yyyy")}</span>
    },
    {
      field: "Expired_Date",
      headerName: "Expired Date",
      headerAlign: "center",
      width: 200,
      renderCell: (params) => <span>{ params.value && format(new Date(params.value), "dd-MM-yyyy")}</span>
    },
    {
      field: "Date_Cancelled",
      headerName: "Date Cancelled",
      headerAlign: "center",
      width: 200,
      renderCell: (params) => <span>{ params.value && format(new Date(params.value), "dd-MM-yyyy")}</span>
    },
    {
      field: "Cancellation_Reason",
      headerName: "Cancellation Reason",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "Transaction_Status",
      headerName: "Transaction Status",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "UMR_Number",
      headerName: "UMR Number",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Three_Party_Capacity_Deployed",
      headerName: "Three Party Capacity Deployed",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "SCM_Partner",
      headerName: "SCM Partner",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Signed_Line_Pct",
      headerName: "Signed Line Pct",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Broker_Order_Pct",
      headerName: "Broker Order Pct",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Signed_Order_Pct",
      headerName: "Signed Order Pct",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Broker_Commision_Pct",
      headerName: "Broker Commission Pct",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "Coverholder_Commision_Pct",
      headerName: "Coverholder Commission Pct",
      headerAlign: "center",
      width: 250,
    },
    {
      field: "Broker_Reference",
      headerName: "Broker Reference",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "Underwriter",
      headerName: "Underwriter",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "MOP",
      headerName: "MOP",
      headerAlign: "center",
      width: 150,
    },
    {
      field: "Broker",
      headerName: "Broker",
      headerAlign: "center",
      width: 200,
    }
  ];
  

  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
      ? pageState?.page
      : pageState?.page - 1;
  };

  return (
    <Box style={agedReportContainer}>
      <div style={agedReportText}>
        <Typography
          variant="h3"
          style={{
            color: "#FF5A01",
            fontSize: "24px",
            margin: "10px 0px 15px 0px",
          }}
        >
          Agedebt Report Details
        </Typography>
        <Typography
          variant="h3"
          style={{
            // color: "#FF5A01",
            fontSize: "18px",
            margin: "10px 0px 15px 0px",
          }}
        >
          File Name : {localStorage.getItem('selectedFileName')}
        </Typography>
      </div>

      <Grid item>
        <div
          style={{
            height: "calc(100vh - 313px)",
            position: "relative",
            display: "flex",
            flexDirection: "row-reverse",
            marginTop: "8px",
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            getRowId={(row) => pageState?.data.indexOf(row)}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            rowsPerPageOptions={[2, 10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize)
                );
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            sx={{
              "& .MuiDataGrid-cellContent": {
                textAlign: "start",
              },
              "& .MuiDataGrid-columnHeader[data-field='Comments']": {
                minWidth: toggle?.isOpen
                  ? "209.137px !important"
                  : "209.137px !important",
              },
            }}
          />
          <Stack
            style={{
              position: "absolute",
              bottom: "8px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack>
        </div>
      </Grid>
    </Box>
  );
};
